import { render, staticRenderFns } from "./ExploradorArchivoExpedienteV2.vue?vue&type=template&id=412acae4&scoped=true"
import script from "./ExploradorArchivoExpedienteV2.vue?vue&type=script&lang=js"
export * from "./ExploradorArchivoExpedienteV2.vue?vue&type=script&lang=js"
import style0 from "./ExploradorArchivoExpedienteV2.vue?vue&type=style&index=0&id=412acae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412acae4",
  null
  
)

export default component.exports